import { View, Image, Pressable } from "react-native"
import { customStyles } from "../theme/styles"
import BackButton from "../assets/back.svg"
import React from 'react'

const MCALayout = (props:any) => {
    return (
      <View style={customStyles.appContainer}>
              <View style={customStyles.spacerHorizontal}></View>
              {(!props.onBackPressed) ? <></> : <View style={{ flexDirection: "row" }}>
                  <Pressable style={{ padding: 12 }} onPress={props.onBackPressed}>
                      <BackButton width={30} height={30} />
                  </Pressable>
              </View>}
  
              <View style={{ flex: 1, alignItems: "center" }}>
                  <Image style={customStyles.logo} source={require("../assets/logo.png")} />
                  <View style={{ flex: 1, width: "100%" }}>
                      {props.children}
                  </View>
                  <Image style={customStyles.poweredBy} source={require("../assets/powered_by.png")} />
              </View>
          </View>
    )
  }
  
  export default MCALayout